import {
  Button,
  Callout,
  FormGroup,
  HTMLSelect,
  InputGroup,
  TextArea,
} from "@blueprintjs/core";
import {
  MDBCol,
  MDBRow,
} from "mdbreact";
import { observable } from "mobx";
import { observer } from "mobx-react";
import { createViewModel } from "mobx-utils";
import * as React from "react";
import { INotaVar } from "../../model";
import { AppStore } from "../../stores/AppStore";
import { NotaVarStore } from "../../stores/vars/NotaVarStore";
import { toast } from "react-toastify";
import { sortBy, VARS } from "../../utils";

interface NotaVarFormProps {
}

interface NotaVarFormState {
}

@observer
export class NotaVarForm
  extends React.Component<NotaVarFormProps, NotaVarFormState>
{
  focusEl: HTMLElement;
  notaVar: INotaVar;
  saving: boolean = false;

  obs = observable({
    varId: window.location.pathname.split("/")[3] as string
  })

  constructor(props: NotaVarFormProps) {
    super(props);
    this.notaVar = createViewModel(observable({
      nome: "",
      campo: "",
    }));
    AppStore.setTitle("Criar/Editar Variável");
  }

  async componentDidMount() {
    this.focusEl.focus();
    if (this.obs.varId) {
      let notaVar = await NotaVarStore.get(this.obs.varId);
      this.notaVar._id = notaVar._id
      this.notaVar.campo = notaVar.campo
      this.notaVar.descricao = notaVar.descricao
      this.notaVar.nome = notaVar.nome
    }
  }

  handleSave = async () => {

    if (this.notaVar.nome == "") {
      toast.warn('Preencha o campo Nome', {});
      return
    }

    if (this.notaVar.campo == "") {
      toast.warn('Selecione um Campo!', {});
      return
    }

    if (this.notaVar.descricao == "") {
      toast.warn('Preencha o campo Descrição', {});
      return
    }

    try {
      this.saving = true;

      let resp = await NotaVarStore.put(this.notaVar);

      if (resp.data.ok) {

        AppStore.setLocation("/vars");

        toast.success('Variável salva com sucesso', {});

        var interval = setInterval(NotaVarStore.handleRefresh, 500);

      } else {
        toast.error(`Erro salvando variável: ${resp.data.msg}`, {})
      }

    } catch (ex) {
      toast.error(`Erro salvando variável`, {})
    }

    this.saving = false;

  };

  handleCancel = () => {
    AppStore.setLocation("/vars");
  };

  render() {
    let sortedVars = sortBy(VARS, "nome");
    let varOptions = sortedVars?.map(v => {
      return <option key={v.campo} value={v.campo}>{v.nome || v.campo}</option>;
    });

    let selectedVar = VARS.find(v => v.campo == this.notaVar.campo);

    return (
      <div>
        <MDBRow>
          <MDBCol md="6">

            <FormGroup
              label="Nome"
              labelFor="nome"
            >
              <InputGroup
                id="nome"
                inputRef={el => this.focusEl = el}
                defaultValue={this.notaVar.nome}
                onChange={(e: any) => this.notaVar.nome = e.target.value}
              />
            </FormGroup>

            <FormGroup
              label="Campo"
              labelFor="campo"
            >
              <HTMLSelect
                onChange={e => this.notaVar.campo = e.target.value}
                defaultValue={this.notaVar.campo}
              >
                <option value="">Selecionar um campo...</option>
                {varOptions}
              </HTMLSelect>
            </FormGroup>

            <Callout icon="help" style={{ marginTop: 15, marginBottom: 20 }}>
              {selectedVar && selectedVar.descricao || "Sem descrição"}
            </Callout>
            <FormGroup
              label="Descrição"
              labelFor="descricao"
            >
              <TextArea
                defaultValue={this.notaVar.descricao}
                onChange={(e: any) => this.notaVar.descricao = e.target.value}
                style={{ width: "100%", height: 200 }}
              />
            </FormGroup>

            <div className="nz-button-panel">
              <Button
                intent="primary"
                onClick={this.handleSave}
                loading={this.saving}
              >
                Salvar
              </Button>
              <Button disabled={this.saving} onClick={this.handleCancel}>
                Cancelar
              </Button>
            </div>

          </MDBCol>
        </MDBRow>
      </div>
    );
  }
}

export default NotaVarForm;
